var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.icon)?_c('b-icon',{class:_vm.wrapperClass,attrs:{"custom-size":"is-medium","icon":_vm.icon}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }